// keep stateless functions in this folder, and re-export them from here

import type { Session } from "@ory/client";
import { linkToHrefWithHost } from "@saflib/links";
import { kratosEmailVerifiedFromSession } from "@saflib/ory-kratos-sdk";
import { kratosEmailFromSession } from "@saflib/ory-kratos-sdk";
import { accountLinks } from "@vendata/power-up-links";

/** Account MFA page, for the app error alert when an API returns `MFA_REQUIRED`. */
export function powerUpMfaRequiredHref(): string {
  return linkToHrefWithHost(accountLinks.mfa);
}

/** Keep in sync with ADMIN_EMAILS in power-up/dev + deploy env files. */
const adminEmails = [
  "scott@powerassetexchange.com",
  "george@powerassetexchange.com",
  "wally@powerassetexchange.com",
  "casey@powerassetexchange.com",
  // prod-local / Playwright e2e admin (see deploy/env.power-up.prod-local)
  "admin@saf.com",
];

export const isAdminFromSession = (session: Session) => {
  const email = kratosEmailFromSession(session);
  const emailVerified = kratosEmailVerifiedFromSession(session);
  return !!(emailVerified && email && adminEmails.includes(email));
};
